import { render, staticRenderFns } from "./IntroductorySettlementModal.vue?vue&type=template&id=19093651&scoped=true"
import script from "./IntroductorySettlementModal.vue?vue&type=script&lang=js"
export * from "./IntroductorySettlementModal.vue?vue&type=script&lang=js"
import style0 from "./IntroductorySettlementModal.vue?vue&type=style&index=0&id=19093651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19093651",
  null
  
)

export default component.exports